import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SupportPage } from './support';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
	SupportPage,
	],
	imports: [
	TranslateModule,
	IonicPageModule.forChild(SupportPage),
	],
})
export class SupportPageModule {}



// WEBPACK FOOTER //
// ./src/pages/support/support.module.ts